module.exports = __webpack_public_path__ + "img/logo.9068a5c9.png";